import { inject } from 'inversify';
import { HttpClientType, snakeToCamel } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';
import type { IHttpClient } from '@core/http';

export type ITransferBoxRepoResponse = IRepoResponse<200> | IRepoResponse<422, Record<string, any>> | IRepoResponse<400 | 500, string>;

export type ITransferBoxRepo = IRepo<[{ trackCodes: string[] }], ITransferBoxRepoResponse>;

export const TransferBoxRepoType = Symbol.for('TransferBox');

@bind(TransferBoxRepoType)
export class TransferBoxRepo implements ITransferBoxRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ trackCodes }) {
    try {
      const result = await this.httpClient.post({ url: urlMaker('/api/admin/containers/transfer', { track_code: trackCodes }) });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 422 || result.status === 400) {
        if (typeof result.data.errors?.track_code?.[0] === 'string') {
          return {
            status: 400 as 400,
            response: result.data.errors?.track_code?.[0],
          };
        }
        return {
          status: 422 as 422,
          response: snakeToCamel(result.data.errors),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
